import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { shiftsActions, generalActions } from "../actions";
import api from "../services/shifts.service";
import ACTIONS from "../constants";
import { shiftsPagination } from "../selectors/shift.selector";

function* getShifts(state) {
  try {
    yield put(shiftsActions.getShiftsAttempt.pending);
    const shifts = yield call(api.getShiftsRequest, state.payload);
    const pagination = JSON.parse(shifts.headers["x-pagination"]);
    const data = {
      data: shifts.data,
      pagination: pagination,
    };
    yield put(shiftsActions.getShiftsAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(shiftsActions.getShiftsAttempt.error(""));
    } else {
      yield put(shiftsActions.getShiftsAttempt.error(error.message));
    }
  }
}

function* createShift(state) {
  try {
    yield put(shiftsActions.createShiftAttempt.pending);
    yield call(api.createShiftRequest, state.payload);
    // const paginat = yield select(shiftsPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
    };
    const shifts = yield call(api.getShiftsRequest, payload);
    const pagination = JSON.parse(shifts.headers["x-pagination"]);
    const data = {
      data: shifts.data,
      pagination: pagination,
    };
    yield put(shiftsActions.createShiftAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Shift saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(shiftsActions.createShiftAttempt.error(errorObject));
      } else {
        yield put(shiftsActions.createShiftAttempt.error(errorObject.data));
      }
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(shiftsActions.createShiftAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(shiftsActions.createShiftAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateShift(state) {
  try {
    yield put(shiftsActions.updateShiftAttempt.pending);
    yield call(api.updateShiftRequest, state.payload);
    const paginat = yield select(shiftsPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const shifts = yield call(api.getShiftsRequest, payload);
    const pagination = JSON.parse(shifts.headers["x-pagination"]);
    const data = {
      data: shifts.data,
      pagination: pagination,
    };
    yield put(shiftsActions.updateShiftAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Shift updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(shiftsActions.updateShiftAttempt.error(errorObject));
      } else {
        yield put(shiftsActions.updateShiftAttempt.error(errorObject.data));
      }
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(shiftsActions.updateShiftAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(shiftsActions.updateShiftAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteShift(state) {
  try {
    yield put(shiftsActions.deleteShiftAttempt.pending);
    yield call(api.deleteShiftRequest, state.payload);
    const paginat = yield select(shiftsPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const shifts = yield call(api.getShiftsRequest, payload);
    const pagination = JSON.parse(shifts.headers["x-pagination"]);
    const data = {
      data: shifts.data,
      pagination: pagination,
    };
    yield put(shiftsActions.deleteShiftAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Shift deleted",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(shiftsActions.deleteShiftAttempt.error(error.data.detail));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(shiftsActions.deleteShiftAttempt.error(error.data.detail));
    }
    if (errorObject.status === 400) {
      yield put(shiftsActions.deleteShiftAttempt.error(error.data.detail));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* sortShift(state) {
  try {
    yield put(shiftsActions.sortShiftAttempt.pending);
    const budgets = yield call(api.sortShiftsRequest, state.payload);
    const pagination = JSON.parse(budgets.headers["x-pagination"]);
    const data = {
      data: budgets.data,
      pagination: pagination,
    };
    yield put(shiftsActions.sortShiftAttempt.success(data));
  } catch (error) {
    yield put(shiftsActions.sortShiftAttempt.error(error.message));
  }
}

function* assignShift(state) {
  try {
    yield put(shiftsActions.assignShiftAttempt.pending);
    const data = yield call(api.assignShiftRequest, state.payload);
    yield put(shiftsActions.assignShiftAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Shift assigned",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 500) {
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(shiftsActions.assignShiftAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateShiftFlag(state) {
  try {
    yield put(shiftsActions.updateShiftFlagAttempt.pending);
    yield call(api.updateShiftFlagRequest, state.payload);
    yield put(shiftsActions.updateShiftFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Shift flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {}
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SHIFTS_CALL, getShifts),
    takeEvery(ACTIONS.CREATE_SHIFT_CALL, createShift),
    takeEvery(ACTIONS.UPDATE_SHIFT_CALL, updateShift),
    takeEvery(ACTIONS.DELETE_SHIFT_CALL, deleteShift),
    takeEvery(ACTIONS.SORT_SHIFT_CALL, sortShift),
    takeEvery(ACTIONS.ASSIGN_SHIFT_CALL, assignShift),
    takeEvery(ACTIONS.SHIFT_FLAG_CALL, updateShiftFlag),
  ]);
}
